import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { BreakpointService } from '@corporate/ng-tebis-base-components';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';



type UiStore = {
  matchedBreakpoint: string;  
}

const initialState: UiStore = {
  matchedBreakpoint: '',  
};

function createStore(initialState: UiStore) {
  return signalStore(
    withState(initialState),
    withMethods((store, breakpointService = inject(BreakpointService)) => ({
      detectMatchedBreakpoint: rxMethod<void>(
        pipe(
          switchMap(() => {
            return breakpointService.matchedBreakpoint.pipe(
              tapResponse({
                next: result => patchState(store, { matchedBreakpoint: result }),
                error: error => console.error(error)
              })
            );
          })
        )
      ),        
    })),
    withHooks({
      onInit: (store) => {
        store.detectMatchedBreakpoint();
      }
    })
  );
}

export const UiStore = createStore(initialState);

